import React from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import Footer from '../Footer/Footer';

export default function Help() {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="help"
    >
      <Helmet>
        <title>Help - DuskBreakers</title>
        <meta
          name="description"
          content="We're happy to assist you with anything from questions about the minting process or the game, to future plans for the DuskBreakers universe."
        />
      </Helmet>
      <section>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="mb-5">Help</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <p className="mb-4">
                We&apos;re excited to have you here, and we&apos;re also happy to assist you with
                anything from questions about the minting process or the game, to future plans for
                the DuskBreakers universe. Below are the best ways to contact our team:
              </p>

              <div className="row mb-4">
                <div className="col-lg-6">
                  <h3 className="text-large">Discord</h3>
                  <p>
                    Our team and our incredible mods are very active in our Discord chat room.
                    Please start here if you have any questions - chances are that one of our team
                    members or a helpful community member will be able to walk you through your
                    issue. <a href="https://discord.gg/duskbreakers">DuskBreakers on Discord</a>
                  </p>
                </div>
                <div className="col-lg-6">
                  <h3 className="text-large">Twitter</h3>
                  <p>
                    We monitor our Twitter account regularly. You can send us a DM over Twitter if
                    you have a longer or more private question. Please note that our reply times may
                    be slower over Twitter vs Discord.{' '}
                    <a href="https://twitter.com/duskbreakers">DuskBreakers on Twitter</a>
                  </p>
                </div>
              </div>

              <h3 className="text-large">Other Official Links</h3>

              <div className="row">
                <div className="col-lg-6 mb-2">
                  <p>
                    <strong>Website:</strong>
                    <br />
                    <a target="_new" href="https://duskbreakers.gg/">
                      https://duskbreakers.gg/
                    </a>
                  </p>
                  <p>
                    <strong>Twitter:</strong>
                    <br />
                    <a target="_new" href="https://twitter.com/duskbreakers">
                      https://twitter.com/duskbreakers
                    </a>
                  </p>
                  <p>
                    <strong>Discord:</strong>
                    <br />
                    <a target="_new" href="https://discord.gg/duskbreakers">
                      https://discord.gg/duskbreakers
                    </a>
                  </p>
                </div>
                <div className="col-lg-6">
                  <p>
                    <strong>Opensea:</strong>
                    <br />
                    <a target="_new" href="https://opensea.io/collection/duskbreakers">
                      https://opensea.io/collection/duskbreakers
                    </a>
                  </p>
                  <p>
                    <strong>Instagram:</strong>
                    <br />
                    <a target="_new" href="https://www.instagram.com/duskbreakersnft">
                      https://www.instagram.com/duskbreakersnft
                    </a>
                  </p>
                  <p>
                    <strong>Medium:</strong>
                    <br />
                    <a target="_new" href="https://medium.com/metatheoryinc">
                      https://medium.com/metatheoryinc
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*
      <hr className='hazard'/>



      <section>


        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className="h1 mb-4">How This All Works</h2>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">

            <div className="col-lg-3">
              <p><strong>Table of Contents</strong></p>
              <ul className="toc mb-5">
                <li><a href="#getting-started">Getting Started</a></li>
                <li><a href="#how-to-mint">How to Mint</a></li>
              </ul>
            </div>




            <div className="col-lg-9" id="help-collapse">

              <h2 id="getting-started" className="text-start sans-serif mb-4">Getting Started</h2>

              <p>Are you new to crypto and NFTs? Click the button below to show a basic primer on Ethereum and how to purchase NFTs.</p>

              <a role="button" className="btn btn-primary collapsed" data-bs-toggle="collapse" href="#collapseStory"
                 aria-expanded="false" aria-controls="collapseStory">Basic Tutorial</a>

              <div className="collapse" id="collapseStory" aria-expanded="false">

                <h3 className="pt-4 text-large">What is Minting?</h3>

                <p>Non-fungible tokens (NFTs) are unique, digital items with blockchain-managed ownership. Examples include collectibles, game items, digital art, event tickets, and more.</p>
                <p>Minting describes the process of generating a new NFT, in our case a DuskBreakers NFT, which lives on the Ethereum blockchain (ERC 721 standard).</p>

                <h3 className="text-large">NFT Costs and Gas Costs</h3>

                <p>In order to mint your DuskBreakers NFT, you will have to pay two costs in the form of Ether (ETH, a popular cryptocurrency).</p>
                <p>The first fee of 0.06 ETH goes to our team, 100% of which we will use to build subsequent interactive media and game experiences in the DuskBreakers universe.</p>
                <p>The second fee is a general utility cost to transact on the Ethereum blockchain called a “gas fee” or “Gwei.” This gas fee is not collected by our team in any way. If you are unsure of what this means, please <a target="_new" href="https://intercom.help/foundation-529b3c2d3a16/en/articles/4731476-what-is-gas">please read more about gas fees here</a>.</p>
                <p>Gas fees vary over the course of the day based on transaction activity on the Ethereum blockchain. When activity is high, gas costs increase. You may <a target="_new" href="https://ethgas.watch/">track gas cost here</a>. You will have 48 hours to mint the DuskBreakers NFT, so you may mint at any convenient time during that window so as to minimize gas fees.</p>

                 <h3 className="text-large">What You’ll Need</h3>

                <ul>
                  <li><strong>You will need ETH in order to purchase a DuskBreakers NFT.</strong> You can purchase ETH on all major exchanges including Coinbase, FTX, Binance, etc. We recommend you have at least 0.03 ETH extra (on top of NFT cost) to cover the Ethereum network transaction fees (aka gas fees).</li>
                  <li>If you don&apos;t already have a wallet, we recommend getting a Metamask wallet (supported by Chrome, Firefox, Brave, and Edge browser). You can set this up at <a target="_new" href="https://metamask.io/">metamask.io</a>.</li>
                </ul>

                <h3 className="text-large">How to Obtain ETH</h3>
                <p>You’ll need ETH available in your wallet to start minting. You can purchase ETH at an exchange (such as <a target="_new" href="https://www.coinbase.com/">Coinbase</a>) and then transfer the funds to your wallet. Alternatively, you may buy directly through Metamask via a fiat on-ramp solution such as Wyre or Transak.</p>
                <p>For more detailed instructions on how to obtain ETH, please check out this <a target="_new" href="https://support.opensea.io/hc/en-us/articles/360061678354-How-do-I-purchase-Ethereum-ETH-">tutorial on Opensea</a>.</p>

              </div>



              <hr/>



              <h2 id="how-to-mint" className="text-start sans-serif mb-4">How to Mint</h2>

              <p className="mb-4">Winners chosen from our sweepstakes will be notified by email. Please check your spam inbox. You may also check your sweepstakes status by connecting your MetaMask wallet to the <a target="_new" href="https://duskbreakers.gg">duskbreakers.gg</a> website. Winners will be shown a button to mint on the homepage. Winners are allowed to mint over a 48 hour period. Take your time and avoid the gas wars!</p>

              <ol className="help-list">
                <li>
                  <span>1.</span>
                  <div>
                    <p>Sweepstakes winners will be notified by email. Please check your spam inbox. You may also check by signing back into the <a target="_new" href="https://duskbreakers.gg">duskbreakers.gg</a> website.</p>
                  </div>
                </li>
                <li>
                  <span>2.</span>
                  <div>
                    <p>Return to the <a target="_new" href="https://duskbreakers.gg">duskbreakers.gg</a> website.</p>
                  </div>
                </li>
                <li>
                  <span>3.</span>
                  <div>
                    <p>Make sure your metamask wallet has at least 0.12 ETH per NFT you wish to Mint. You may mint up to 2 NFTs if whitelisted. You may mint up to 3 NFTs if you won play-to-mint sweepstakes or were one of the top leaderboard winners.</p>
                    <p>Each NFT mint costs 0.06 ETH, so the additional 0.06 ETH (to total 0.12ETH) per mint is to ensure you can cover gas fees. You have 24 hrs to mint, so we suggest you check periodically until gas fees are low to mint.</p>
                  </div>
                </li>
                <li>
                  <span>4.</span>
                  <div>
                    <p>Connect your Metamask wallet using the Connect Wallet button displayed on the page.</p>
                  </div>
                </li>
                <li>
                  <span>5.</span>
                  <div>
                    <p>Once you’ve approved your wallet to access the page, you should see the mint button (you will have 48 hours to mint).</p>
                  </div>
                </li>
                <li>
                  <span>6.</span>
                  <div>
                    <p>Click “mint” and select how many NFTs you wish to mint (2 maximum per whitelisted wallet) during pre-sale.</p>
                  </div>
                </li>
                <li>
                  <span>7.</span>
                  <div>
                    <p>Approve the transaction that pops up. If Metamask does not automatically appear, click on the Metamask browser extension and confirm in order to approve the transaction. Metamask will show a “confirmed transaction” message once complete.</p>
                  </div>
                </li>
                <li>
                  <span>8.</span>
                  <div>
                    <p>You will be able to view your NFT on <a target="_new" href="https://opensea.io/collection/duskbreakers">OpenSea</a> after it has been minted. It will initially appear as an unrevealed placeholder image - as you see below - but the complete reveal of your DuskBreakers NFT won’t take place until a few days after the mint period. Reveal information will be posted on our official Twitter and Discord. You can learn more about how to create an account on OpenSea using your Metamask Wallet at <a target="_new" href="https://support.opensea.io/hc/en-us/articles/360061676254-How-do-I-create-an-OpenSea-account-">this tutorial here</a>.</p>
                  </div>
                </li>
                <li>
                  <span>8.</span>
                  <div>
                    <p>We will do everything to make the launch as smooth as possible. GLHF from the DuskBreakers Team! </p>
                  </div>
                </li>
              </ol>



            </div>

          </div>


        </div>
      </section>
      */}

      <Footer />
    </m.main>
  );
}
